import { css } from 'linaria';
import { styled } from 'linaria/react';
import React, { useState } from 'react';
import { Avatar, Tablist, Tab } from 'evergreen-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';

import { useStore } from 'effector-react';
import { ProfileInformationPage } from 'src/features/home/features/profile/features/profile-information.page';
import { ProfileInterestsPage } from 'src/features/home/features/profile/features/profile-interests.page';
import { Block } from 'src/ui/atoms/block';
import { Page } from 'src/ui/templates/page';
import { updateUserAvatarFx, user$ } from 'src/store/user.store';

const PageTitle = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 32px;
	margin-bottom: 32px;
`;

const form = css`
	label {
		color: var(--gray900);
	}
`;
const FileInput = styled.label`
	display: flex;
	position: relative;
`;
const UploadIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,.3);
	border-radius: 50%;
`;

export const ProfilePage = () => {
	const user = useStore(user$);
	const [currentTab, changeCurrentTab] = useState<'information' | 'interests'>('information');

	return (
		<Page>
			<Block className={form}>
				<PageTitle>
					Profile
					<FileInput htmlFor={'avatar'}>
						<Avatar
							size={50}
							name={[user?.details.first_name, user?.details.last_name].join(' ')}
							src={user?.details.avatar || undefined}
						/>
						<UploadIconContainer>
							<FontAwesomeIcon
								size={'xs'}
								icon={faUpload}
								color={'white'}
							/>
						</UploadIconContainer>
						<input
							hidden
							onChange={e => {
								const file = e.target.files && e.target.files[0];
								if (file) {
									updateUserAvatarFx({ file });
								}
							}}
							multiple={false}
							accept={'jpg,png'}
							type="file"
							id='avatar'
						/>
					</FileInput>
				</PageTitle>
				<Tablist style={{ marginBottom: 32 }}>
					<Tab
						style={{ fontSize: 16, marginLeft: 0 }}
						isSelected={currentTab === 'information'}
						onSelect={() => changeCurrentTab('information')}
					>
						Information
					</Tab>
					<Tab
						style={{ fontSize: 16 }}
						isSelected={currentTab === 'interests'}
						onSelect={() => changeCurrentTab('interests')}
					>
						Interests
					</Tab>
				</Tablist>
				{currentTab === 'information' && (
					<ProfileInformationPage/>
				)}
				{currentTab === 'interests' && (
					<ProfileInterestsPage/>
				)}
			</Block>
		</Page>
	);
};
